import { lazy, Suspense } from 'react';

import { Switch } from 'react-router-dom';

import { RoleName } from '@m/types/api/iam/Iam';
import { FlexibleListPageWrapper } from 'apps/admin/AdminApp.styled';
import AuthenticatedRoute from 'apps/admin/components/AuthenticatedRoute';

const ClientReportingPage = lazy(() => import('apps/admin/containers/ClientReporting/page'));

export const reportingRoutesConfig = [
  {
    exact: true,
    path: '/client-reporting',
    breadcrumb: 'Reporting',
    roles: [
      RoleName.SYSTEM_ADMIN,
      RoleName.SUPER_ADMIN,
      RoleName.OPERATIONAL_ADMIN,
      RoleName.LEADER,
      RoleName.MANAGER,
    ],
    component: AuthenticatedRoute,
    children: (
      <Suspense fallback={null}>
        <FlexibleListPageWrapper>
          <ClientReportingPage />
        </FlexibleListPageWrapper>
      </Suspense>
    ),
  },
  // Note: /reporting route is defined as a public route in Admin.tsx for the prototype
];

export default function ReportingRoutes() {
  return (
    <Switch>
      {reportingRoutesConfig.map(
        ({ component: Component, breadcrumb, ...props }) =>
          Component && <Component key={props.path} {...props} />,
      )}
    </Switch>
  );
}
